
import Navbar from '../../home/components/Navbar';
import Footer from '../../home/components/Footer';
import {
  ServicePageHero,
  ServiceProcess,
  ServiceTrust,
  ServiceContact,
} from '../../../components/feature';
import { STORM_DAMAGE_DATA, SERVICE_FORM_ENDPOINT } from '../../../data/servicePageData';

export default function StormDamagePage() {
  const { title, subtitle, heroImage, processTitle, processSubtitle, steps } = STORM_DAMAGE_DATA;

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <ServicePageHero title={title} subtitle={subtitle} backgroundImage={heroImage} />
      <ServiceProcess title={processTitle} subtitle={processSubtitle} steps={steps} />
      <ServiceTrust serviceName="Storm Damage" />
      <ServiceContact serviceName="Storm Damage" formEndpoint={SERVICE_FORM_ENDPOINT} />
      <Footer />
    </div>
  );
}
